// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__378Ja","footer":"ModalFilter_footer__3IvgO"};